export default {
  title: {
    'zh-cn': '角色管理',
    'zh-tw': '角色管理',
    'en': 'Role Management'
  },
  // 按钮和操作
  add: {
    'zh-cn': '新增',
    'zh-tw': '新增',
    'en': 'Add'
  },
  save: {
    'zh-cn': '保存',
    'zh-tw': '保存',
    'en': 'Save'
  },
  // 表格列
  roleName: {
    'zh-cn': '角色名称',
    'zh-tw': '角色名稱',
    'en': 'Role Name'
  },
  remark: {
    'zh-cn': '备注',
    'zh-tw': '備註',
    'en': 'Remark'
  },
  defaultRole: {
    'zh-cn': '默认角色',
    'zh-tw': '默認角色',
    'en': 'Default Role'
  },
  enable: {
    'zh-cn': '启用',
    'zh-tw': '啟用',
    'en': 'Enable'
  },
  operation: {
    'zh-cn': '操作',
    'zh-tw': '操作',
    'en': 'Operation'
  },
  // 表格内容
  yes: {
    'zh-cn': '是',
    'zh-tw': '是',
    'en': 'Yes'
  },
  no: {
    'zh-cn': '否',
    'zh-tw': '否',
    'en': 'No'
  },
  // 右侧卡片
  permissionEdit: {
    'zh-cn': '权限编辑',
    'zh-tw': '權限編輯',
    'en': 'Permission Edit'
  },
  controlPermissionSection: {
    'zh-cn': '页面内控件权限',
    'zh-tw': '頁面內控件權限',
    'en': 'In-page control permissions'
  },
  // 对话框标题
  editRole: {
    'zh-cn': '编辑角色',
    'zh-tw': '編輯角色',
    'en': 'Edit Role'
  },
  addRole: {
    'zh-cn': '新增角色',
    'zh-tw': '新增角色',
    'en': 'Add Role'
  },
  // 消息提示
  requestFailed: {
    'zh-cn': '请求失败',
    'zh-tw': '請求失敗',
    'en': 'Request failed'
  },
  enableSuccess: {
    'zh-cn': '启用成功',
    'zh-tw': '啟用成功',
    'en': 'Enable successful'
  },
  disableSuccess: {
    'zh-cn': '禁用成功',
    'zh-tw': '禁用成功',
    'en': 'Disable successful'
  },
  deleteConfirm: {
    'zh-cn': '您确定删除该角色吗？',
    'zh-tw': '您確定刪除該角色嗎？',
    'en': 'Are you sure to delete this role?'
  },
  deleteSuccess: {
    'zh-cn': '删除成功',
    'zh-tw': '刪除成功',
    'en': 'Delete successful'
  },
  deleteFailed: {
    'zh-cn': '删除失败',
    'zh-tw': '刪除失敗',
    'en': 'Delete failed'
  },
  permissionModifySuccess: {
    'zh-cn': '权限修改成功',
    'zh-tw': '權限修改成功',
    'en': 'Permission modified successfully'
  },
  // 角色类型
  defaultAccount: {
    'zh-cn': '默认账号',
    'zh-tw': '默認賬號',
    'en': 'Default Account'
  },
  commonAccount: {
    'zh-cn': '普通账号',
    'zh-tw': '普通賬號',
    'en': 'Common Account'
  },
  // 搜索表单（已注释但保留）
  roleType: {
    'zh-cn': '角色类型',
    'zh-tw': '角色類型',
    'en': 'Role Type'
  },
  pleaseInputKeyword: {
    'zh-cn': '请输入关键字',
    'zh-tw': '請輸入關鍵字',
    'en': 'Please input keyword'
  },
  // 表单标签
  roleNameLabel: {
    'zh-cn': '角色名称',
    'zh-tw': '角色名稱',
    'en': 'Role Name'
  },
  defaultRoleLabel: {
    'zh-cn': '默认角色',
    'zh-tw': '默認角色',
    'en': 'Default Role'
  },
  enableLabel: {
    'zh-cn': '启用',
    'zh-tw': '啟用',
    'en': 'Enable'
  },
  remarkLabel: {
    'zh-cn': '备注',
    'zh-tw': '備註',
    'en': 'Remark'
  },
  // 消息提示（子组件）
  addSuccess: {
    'zh-cn': '新增成功',
    'zh-tw': '新增成功',
    'en': 'Add successful'
  },
  editSuccess: {
    'zh-cn': '编辑成功',
    'zh-tw': '編輯成功',
    'en': 'Edit successful'
  }
}

